export default {
	home: 'Home',
	about: 'About Us',
	services: 'Services',
	contact: 'Contact Us',
	shipping: 'Transport Service',
	refrigerated: 'Refrigerated Cargo',
	operable: 'Operable Cargo',
	consultation: 'Product Compliance Consulting',
	business: 'Business Cooperation',
	recruitment: 'Careers',
	switchLanguage: 'Switch Language',
	language: 'Chinese',
	english: 'English',
	contactUs: 'Contact Us',
	homeTitle: "Chemfast International Transportation", // 泛思特国际运输
	homeSubtitle: "Professional · Safe · Efficient", // 专业 安全 高效
	homeFst: {
		bannerTitle: '专业物流解决方案',
		bannerDesc: '为您提供高效、安全、可靠的全球运输服务',
		services: {
			title: 'Professional Transportation Solutions',
			tag: 'Our Services',
			list: [{
					title: 'Cold-chain Transportation',
					desc: 'Provide cold-chain transportation solutions to precise temperature control at all levels and ensure consistent quality of transported temperature-controlled products',
					features: ['Full temperature range coverage ', 'Real-time temperature monitoring system',
						'Pharmacy-level cold-chain packaging',
						'7×24h intelligent alarm for immediate response to exceptions'
					]
				},
				{
					title: 'Transportation of Hazardous Goods',
					desc: 'Internationally certified transportation expert of hazardous goods, providing safe transportation solutions for all categories of dangerous cargo',
					features: ['International-certified qualification', 'Professional hazardous goods handling team',
						'Compliant transportation solutions',
						'Emergency response system'
					]
				},
				{
					title: 'Transportation of Pharmaceuticals and Chemicals',
					desc: 'Professional transportation service in compliance with GMP standards, meeting the high-standard transportation requirements for pharmaceuticals and chemicals',
					features: ['GMP standard transportation environment', 'Professional temperature control system',
						'Whole process traceable',
						'Quality compliance guarantee'
					]
				},
				{
					title: 'Transportation of Battery-included Cargo',
					desc: 'Professional transportation service for lithium batteries and battery-included equipment in compliance with international air and maritime transportation standards',
					features: ['Safe lithium battery package in compliance with international standards',
						'Professional isolation measures',
						'IATA/IMDG compliance', 'Safe transportation certification'
					]
				},
				{
					title: 'Transportation of Heavy and Irregular Cargo',
					desc: 'For heavy and irregular cargo, provide efficient and safe professional transportation solutions, fully meeting the demand for global transportation of oversized cargo such as engineering machinery and special equipment',
					features: ['Exclusive and customized loading/unloading solutions', 'Accurate transportation route planning',
						'Special transportation equipment in place', 'Global door-to-door service'
					]

				}
			]
		}
	},
	aboutFst: {
		companyImageCaption: "Beijing Headquarters Office",
		stats: {
			airlines: "well-known airlines contracted",
			clients: "enterprises served",
			employees: "employees",
			warehouse: "self-owned warehouses"
		},
		title: "About Chemfast",
		heroTitle: "About Chemfast",
		companyIntro: {
			title: "Company Profile",
			subtitle: "Professional Provider of International Transportation Solutions",
			qualifications: {
				title: "Our Qualifications",
				part1: 'Beijing Chemfast International Transportation Co., Ltd. is a first-class freight forwarding company approved by the Civil Aviation Administration of China and also a member of IATA, an international civil aviation organization. Established in 2005, it owns totally five operating sites located in ',
				highlight: 'Beijing, Shanghai, Guangzhou, Zhengzhou and Chengdu',
				part2: '.'
			},
			coreBusiness: {
				title: "Core Businesses",
				services: [
					"General Cargo Transportation",
					"Transportation of Dangerous Goods",
					"Lithium Battery Products",
					"Cold-chain Medicine",
					"Biopharmaceuticals",
					"Transportation of Irregular Cargo",
					"Door-to-Door Service"
				]
			},
			advantages: {
				title: "Advantages",
				items: [{
						title: "Aviation Resources",
						content: "Execute contracts with more than 20 airlines covering main air routes and networks across the globe"
					},
					{
						title: "Professional Team",
						content: "200+ professionals provide full-process service"
					},
					{
						title: "Enterprise Clients",
						content: "Serve 3000+ production, sales, trading and import and export enterprises"
					},
					{
						title: "Warehousing Facilities",
						content: "4000㎡ self-owned warehouses including thermostatic/refrigerating/ freezing warehouses"
					}
				]
			},
			mission: {
				title: "Service Philosophy",
				prefix: 'Treat',
				keywords1: ['Honesty'], // 诚信
				keywords2: 'as the foundation, adhere to the service philosophy of ', // 为本，秉持
				keywords: [
					'Professionalism, Quality and Efficiency,', // 专业、优质、高效
					'Visual innovation mode of Internet technology', // 互联网科技可视化
					'Door-To-Door full-chain' // 门到门全链条
				],
				middle1: 'leverage the', // 的服务理念，结合
				middle2: 'to construct a powerful global cargo transportation network and provide ', // 的创新模式，构建强大的全球货物运输网络，为客户提供
				suffix: 'transportation solutions for customers.' // 运输解决方案
			}
		},

		certificates: {
			title: "Qualification Certificates",
			subtitle: "Professional Certificates Guarantee Transportation Safety",
			cert1: "China Air Transport Association - Certificate of Membership",
			cert2: "Quality Management System Certificate",
			cert3: "Member of WCA Dangerous Goods",
			cert4: "Member of WCA Pharma",
			cert5: "Testing Report for Temperature Display Device of Cold Storage",
			cert6: "Certificate for Civil Aviation Service"
		},
		timeline: {
			title: "History",
			subtitle: "Significant Milestones",
			events: [{
					year: "2005",
					title: "Company established",
					content: "Company established",
				},
				{
					year: "2016",
					title: "",
					content: "Shanghai Branch was established and an IT team was established for independent R&D",
				},
				{
					year: "2018",
					title: "",
					content: "Guangzhou Branch was established",
				},
				{
					year: "2019",
					title: "",
					content: "Joined WCA",
				},
				{
					year: "2022",
					title: "",
					content: "Zhengzhou Branch was established",
				},
				{
					year: "2023",
					title: "",
					content: "Chengdu Branch was established",
				},
				{
					year: "2025",
					title: "",
					content: "Developing continuously...",
				}
			]
		},
		branches: {
			title: "Nationwide Services",
			subtitle: "Transportation Network Covering Main Economic Regions Across China",
			beijing: {
				city: "Beijing Headquarters",
				year: "established in 2005",
				desc: "Beijing Chemfast International Transportation Co., Ltd. was established in 2005. As a first-class freight forwarding company approved by the Ministry of Commerce of the People's Republic of China and the China Air Transport Association, it specializes in the international transportation business of exported chemicals, hazardous gooods, cold-chain medicines, lithium battery products, high-end consumer goods and other cargo.",
				officeArea: "1400㎡",
				warehouseArea: "2500㎡"
			},
			shanghai: {
				city: "Shanghai Branch",
				year: "established in 2016",
				desc: "The main businesses of Beijing Chemfast International Transportation Co., Ltd. (Shanghai Branch) include air transportation, maritime transportation and inland transportation. It owns an independent warehousing department covering an area of 670m² and has set up a cold storage with multiple temperature zones.",
				officeArea: "275㎡",
				warehouseArea: "670㎡"
			},
			guangzhou: {
				city: "Guangzhou Branch",
				year: "established in 2018",
				desc: "Beijing Chemfast International Transportation Co., Ltd. (Guangzhou Branch) has the main businesses including international air transportation, inland transportation, combined transportation between Hong Kong, Macao and Greater Bay, etc. It owns an office area of around 200m² and a 660m² independent warehousing department with self-built cold storage.",
				officeArea: "140㎡",
				warehouseArea: "660㎡"
			},
			zhengzhou: {
				city: "Zhengzhou Branch",
				year: "established in 2022",
				desc: "Beijing Chemfast International Transportation Co., Ltd. (Zhengzhou Branch) was established in 2022. It has an office area of 180m² and a 430m² independent warehousing department.",
				officeArea: "180㎡",
				warehouseArea: "430㎡"
			},
			chengdu: {
				city: "Chengdu Branch",
				year: "established in 2023",
				desc: "Beijing Chemfast International Transportation Co., Ltd. (Chengdu Branch) was established in 2023. It has a 450m² independent warehousing department.",
				officeArea: "150㎡",
				warehouseArea: "450㎡"
			}
		},
		common: {
			established: "",
			officeArea: "Office area",
			warehouseArea: "Warehouse area",
			loading: "Loading…"
		},
	},

	hero: {
		title: 'Expert of Global Logistics Solutions',
		subtitle: 'Chemfast International Transportation - Connecting Every Corner of the World'
	},
	NavigationServices: {
		airTitle: 'Airline Collaboration Chain of Chemfast',
		airDescription: 'Chemfast International Transportation has executed contracts with more than 20 airlines covering global air routes and networks such as Europe, America, South America, Southeast Asia, India, Middle East, Africa, and Australia',
		seaTitle: 'Chemfast · Ocean Freight',
		seaDescription: 'Cooperate with Main Global Shipping Companies and Provide Worldwide Maritime Transportation Service',
		wcaTitle: "WCA Membership",
		wcaDescription: "Chemfast  is a member of WCA (World Cargo Alliance) and able to provide comprehensive services all over the world, offering the most valuable services to guests worldwide, while ensuring your cargo being handled in an optimal manner."
	},
	refrigeratedGoods: {
		title: "Categories of Refrigerated Cargo",
		subtitle: "Precise Temperature Control · Visible Full-process · Safe and Reliable",
		introduction: "We provide professional temperature control service against temperature-sensitive cargo including chemicals, medicines, fresh food, etc., keeping your cargo in optimal condition during the transportation.",
		viewDetails: "View Details",
		tempRangeTitle: "我们的温控范围",
		tempRecorder: {
			title: "实时温度数据",
			altText: "温度记录仪",
			downloadBtn: "下载完整报告",
			data: [{
					label: "当前温度",
					value: "22.5°C",
					highlight: false
				},
				{
					label: "平均温度",
					value: "21.8°C",
					highlight: false
				},
				{
					label: "最高温度",
					value: "25.2°C",
					highlight: true
				},
				{
					label: "最低温度",
					value: "18.3°C",
					highlight: true
				},
				{
					label: "温度波动",
					value: "±1.2°C",
					highlight: false
				},
				{
					label: "记录时长",
					value: "36小时",
					highlight: false
				}
			]
		},
		features: [{
				icon: "fas fa-temperature-low",
				title: "Precise Temperature Control",
				description: "Precise control within ±1°C to transport various temperature-sensitive cargo",
				color: "#4a89dc"
			},
			{
				icon: "fas fa-map-marked-alt",
				title: "Full-process Tracking",
				description: "GPS positioning + real-time temperature monitoring, ensuring whole transportation process visible",
				color: "#3bafda"
			},
			{
				icon: "fas fa-shield-alt",
				title: "Safety Guarantee",
				description: "Professional team + emergency plan to ensure cargo intact",
				color: "#37bc9b"
			},
			{
				icon: "fas fa-file-alt",
				title: "Full Reports",
				description: "Provide temperature records and analysis reports for the whole transportation process",
				color: "#f6bb42"
			}
		],
		tempRanges: [{
				temp: "-25°C",
				label: "超低温冷冻",
				color: "#4fc1e9"
			},
			{
				temp: "-18°C",
				label: "标准冷冻",
				color: "#5d9cec"
			},
			{
				temp: "2-8°C",
				label: "冷藏",
				color: "#a0d468"
			},
			{
				temp: "15-25°C",
				label: "恒温",
				color: "#ffce54"
			},
			{
				temp: "30°C+",
				label: "高温控制",
				color: "#ed5565"
			}
		],
		activeControl: {
			title: "Active Temperature Control Service",
			subtitle: "Real-time Monitoring · Automatic Adjustment · Data Recording",
			equipment: [{
					name: "RKNt2 Dry Ice Container",
					image: "rknT2.jpeg",
					description: "Applicable to transportation of frozen cargo under -18°C, with built-in lithium battery system for power supply",
					specs: [{
							icon: "fas fa-thermometer-half",
							text: "-25°C to +25°C"
						},
						{
							icon: "fas fa-battery-full",
							text: "72h battery life"
						},
						{
							icon: "fas fa-weight",
							text: "45kg"
						}
					]
				},
				{
					name: "RAPe2 Electric Container",
					image: "RLP.jpg",
					description: "New-generation temperature control container, supporting remote monitoring and adjustment",
					specs: [{
							icon: "fas fa-thermometer-half",
							text: "±1°C precision"
						},
						{
							icon: "fas fa-wifi",
							text: "real-time data transmission"
						},
						{
							icon: "fas fa-ruler-combined",
							text: "1200×800×800mm"
						}
					]
				},
				// {
				// 	name: "海尔温控箱",
				// 	image: "Haier.jpg",
				// 	description: "冷藏恒温控制，适用于药品运输",
				// 	specs: [{
				// 			icon: "fas fa-thermometer-half",
				// 			text: "+0°C~+25°C"
				// 		},
				// 		{
				// 			icon: "fas fa-chart-line",
				// 			text: "温度曲线记录"
				// 		},
				// 		{
				// 			icon: "fas fa-bell",
				// 			text: "异常报警"
				// 		}
				// 	]
				// },
				{
					name: "Hybrid Refrigerating Container skyCell",
					image: "混动.jpeg",
					description: "Utilize hybrid constant temperature control, integrate various functions including real-time recording of temperature curve, multi-stage alarm against power-off and temperature difference and remote monitoring, and apply to the cold-chain transportation of high-value medicines, ensuring the whole visible, controllable and traceable transportation process.",
					specs: [{
							icon: "fas fa-thermometer-half",
							text: "+0°C - +25°C constant temperature"
						},
						{
							icon: "fas fa-chart-line",
							text: "real-time temperature recording"
						},
						{
							icon: "fas fa-bell",
							text: "exception and power-off alarm"
						}
					]
				}

			]
		},
		passiveControl: {
			title: "Passive Temperature Control Service",
			subtitle: "Economical and Highly Efficient · Flexible Customization · Preferred for Short-distance Transportation",
			options: [{
					icon: "pmx.jpg",
					title: "Foam box solution",
					description: "Economical and highly efficient temperature control packaging solution",
					color: "#8cc152",
					features: [
						"Multiple optional dimensions",
						"Customizable comparting",
						"Applicable to 2-8°C refrigerated transportation",
						"72h thermal insulation"
					]
				},
				{
					icon: "bp.jpg",
					title: "Combination of refrigerants",
					description: "Prepare the optimal refrigerating solution based on demand",
					color: "#3bafda",
					features: [
						"Dry ice/ice row/ice pack",
						"Precise dosage calculation",
						"Continuously controllable temperature",
						"Eco-friendly material"
					]
				},
				{
					icon: "dz.jpg",
					title: "Customized packaging",
					description: "Exclusive solutions for special cargo",
					color: "#da4453",
					features: [
						"One-to-one design",
						"Multilayer thermal insulation structure",
						"Shock-resistant and anti-drop",
						"Reusable",
						"Quick response to provide customized service"
					]
				}
			]
		}
	},
	cargoTypes: {
		title: 'Categories of Operable Cargo',
		subtitle: 'Professional Handling of Various Cargo Fully Conforming to Safety Specifications',
		general: {
			title: 'General Cargo',
			description: 'Solutions to safe transportation of conventional cargo',
			commonItems: 'Fine chemicals, Active Pharmaceutical Ingredients, Biological products and materials, Pesticides, Mechanical parts, Food, Clothes, etc.:',
			tags: [
				'Fine chemicals',
				'Active Pharmaceutical Ingredients',
				'Biological products and materials',
				'Pesticides',
				'Mechanical parts',
				'Food',
				'Clothes'
			]
		},
		dangerous: {
			title: 'Hazardous Goods',
			description: 'Professional transportation solutions for hazardous goods',
			classes: [{
					class: 'Category 1\nExplosives',
					name: '',
					note: 'Classified into 1.1-1.6 classes based on hazard level',
				},
				{
					class: 'Category 2 \nGas',
					name: '',
					subclass: '',
					example: 'Aerosol and lighter',
					unNumber: 'UN1950 / UN1075',
				},
				{
					class: 'Category 3 \nFlammable liquid',
					name: '',
					subclass: '',
					example: 'Paint, alcohol and gasoline',
					unNumber: 'UN1203 / UN1170',
				},
				{
					class: 'Category 4 \nFlammable, Self-Combustible & Water-Reactive Substances',
					name: '',
					subclasses: [{
							subclass: '4.1 Flammable solid',
							name: '',
							example: 'Alcohol wipe and peptide powder',
							unNumber: 'UN1331',
						},
						{
							subclass: '4.2 Self-igniting substance',
							name: '',
							example: 'Peptide powder',
							unNumber: 'UN1350',
						},
						{
							subclass: '4.3 Substances emitting flammable gases when contacting water',
							name: '',
							example: 'Calcium hydride',
							unNumber: 'UN1404',
						},
					],
				},
				{
					class: 'Category 5 \nOxidant and organic peroxided cargo',
					name: '',
					subclasses: [{
							subclass: '5.1 Oxidant',
							name: '',
							example: 'Potassium nitrate and hydrogen peroxide',
							unNumber: 'UN2067 / UN1942',
						},
						{
							subclass: '5.2 Organic peroxide',
							name: '',
							example: 'Peroxide and hardening agent',
							unNumber: 'UN3105 / UN1942',
						},
					],
				},
				{
					class: 'Category 6\n Poisonous and infectious substance',
					name: '',
					subclasses: [{
							subclass: '6.1 Poisonous substance',
							name: '',
							example: 'Camptothecin and strain of influenza virus',
							unNumber: 'UN1541',
						},
						{
							subclass: '6.2 Infectious substance',
							name: '',
							example: 'Pathogenic bacterium and virus',
							unNumber: 'UN2811 / UN2913',
						},
					],
				},
				{
					class: 'Category 7\n Radioactive substance',
					name: '',
					note: 'Classified into class I-III based on radiation level',
					example: 'Radioactive substance for medical and industrial use',
				},
				{
					class: 'Category 8\n Corrosive substance',
					name: '',
					example: 'Heptafluorobutyric acid',
					unNumber: 'UN2794 / UN1830',
				},
				{
					class: 'Category 9\n Other hazardous goods and substances harmful to the environment',
					name: '',
					example: 'Motorcycle and chemical',
					unNumber: 'UN1845 / UN3090',
				}
			],
			notes: {
				title: 'Important Instructions for Cargo Handling',
				items: [
					'Dangerous package is required for transportation of hazardous goods',
					'Package must meet requirements of DGR',
					{
						title: 'Cargo of conflicting categories cannot be transported together',
						items: ['3≠5.1', '4.2≠5.1', '4.3≠8']
					}
				]
			}
		},

		special: {
			title: 'Exclusive Solutions for Special Cargo',
			description: 'Customized solutions for special cargo',
			items: [{
					icon: 'fas fa-temperature-low',
					name: 'Temperature control cargo'
				},
				{
					icon: 'fas fa-lock',
					name: 'High-value products'
				},
				{
					icon: 'fas fa-dove',
					name: 'Live animal'
				},
				{
					icon: 'fas fa-prescription-bottle-alt',
					name: 'Medicines'
				},
				{
					icon: 'fas fa-flask',
					name: 'Laboratory sample'
				},
				{
					icon: 'fas fa-umbrella-beach',
					name: 'Perishable food'
				},
				{
					icon: 'fas fa-pallet',
					name: 'Oversized cargo'
				},
				{
					icon: 'fa-solid fa-glass-cheers',
					name: 'Fragile products'
				}
			]
		}
	},
	common: {
		example: '',
		unNumber: 'UN编号'
	},
	operableGoods: {
		title: "Categories of Operable Cargo",
		subtitle: "专业处理各类货物运输需求",
		generalCargo: {
			title: "普货运输",
			description: "常规货物安全运输解决方案",
			items: "精细化工、原料药、生物制品材料、农药、机械配件、食品、服装等",
			tags: ["精细化工", "原料药", "生物制药", "农药", "机械配件"]
		},
		dangerousGoods: {
			title: "危品运输",
			description: "专业危险品运输解决方案",
			types: [{
					class: "1类",
					name: "爆炸品",
					examples: "火药、雷管、烟花"
				},
				{
					class: "2类",
					name: "气体",
					examples: "压缩氧、液化气"
				},
				{
					class: "3类",
					name: "易燃液体",
					examples: "汽油、酒精、油漆"
				},
				{
					class: "4类",
					name: "易燃固体",
					examples: "硫磺、火柴"
				},
				{
					class: "5类",
					name: "氧化剂",
					examples: "双氧水、硝酸铵"
				},
				{
					class: "6类",
					name: "毒害品",
					examples: "农药、氰化物"
				},
				{
					class: "7类",
					name: "放射性物质",
					examples: "铀、钴60"
				},
				{
					class: "8类",
					name: "腐蚀品",
					examples: "硫酸、氢氧化钠"
				},
				{
					class: "9类",
					name: "杂项",
					examples: "锂电池、石棉"
				}
			]
		},
		specialGoods: {
			title: "特殊货物",
			description: "定制化特殊货物运输方案",
			items: [{
					name: "锂电池",
					icon: "battery-full"
				},
				{
					name: "汽车",
					icon: "car"
				},
				{
					name: "发动机",
					icon: "cog"
				},
				{
					name: "异形货物",
					icon: "box-open"
				},
				{
					name: "超大件货物",
					icon: "radiation"
				}
			]
		}
	},
	recruitmentTitle: "Join Chemfast",
	recruitmentIntro: "We are looking for enthusiastic and talented professionals and hope they can join our team. Here, you will have the opportunity to show your brilliance in the global logistics field and work together with other industry elites to jointly promote the innovation and development of the logistics industry.",
	joinUs: {
		filterTitle: '筛选条件',
		department: '部门',
		location: '工作地点',
		jobType: '职位类型',
		allDepartments: '全部部门',
		allLocations: '全部地点',
		allJobTypes: '全部类型',
		sales: '销售部',
		marketing: '市场部',
		service: '客服部',
		tech: '航线部',
		fullTime: '全职',
		partTime: '兼职',
		internship: '实习',
		beijing: "北京",
		shanghai: "上海",
		guangzhou: "广州",
		zhengzhou: "郑州",
		chengdu: "成都",
		openPositions: '开放职位',
		positionsAvailable: '个职位',
		viewDetails: '查看详情',
		noJobsFound: '未找到符合条件的职位',
		search: '搜索',
		resetFilters: '重置',
		departmentLabel: '部门：',
		locationLabel: '工作地点：',
		typeLabel: '职位类型：',
		howToApply: '如何申请',
		contactPrompt: '如果您对该职位感兴趣，请通过以下方式联系我们：',
		jobs: [{
				id: 1,
				title: '货运代理销售',
				department: '销售部',
				location: '北京',
				type: '全职',
				description: '<h3>职位描述</h3><ul><li>根据公司市场战略目标，负责公司国内货运代理业务的销售和推广工作</li><li>利用运价资源，通过各类网络平台及展会拓展、发展新客户</li><li>调查了解客户的需求和相关市场讯息，制定货代销售方案及报价</li></ul><h3>职位要求</h3><ul><li>大专及以上学历，有销售工作经验优先</li><li>需要有英语基础</li><li>良好的沟通能力和团队协作精神</li></ul>'
			},
			{
				id: 2,
				title: '货运代理专员',
				department: '航线部',
				location: '北京',
				type: '全职',
				description: '<h3>职位描述</h3><ul><li>熟悉空运出口和订舱流程，熟悉北京市场的航线产品，准确定价</li><li>协助销售完成毛利任务和航线关联的业绩考核</li><li>对内报价，推广优秀的航线产品，对空运市场动态反应敏锐，与同行和航司协调航班计划</li></ul><h3>职位要求</h3><ul><li>大专及以上学历，有良好的英语基础</li><li>3-5年同岗位出口空运航线相关工作经验</li></ul>'
			},
			{
				id: 3,
				title: '市场专员',
				department: '市场部',
				location: '北京',
				type: '全职',
				description: '<h3>职位描述</h3><ul><li>协助航线主订人员做好与订舱航司及合作代理的工作对接;</li><li>及时准确回复客人的价格及航线方案问询，把控好卖价规则;</li><li>跟踪已订舱货物的操作流程，与公司销售、客服操作部门做好配合，信息做及时反馈和传递;</li><li>英语四级以上，具有一定的英语听说读写能力</li></ul>'
			},
			{
				id: 4,
				title: '货代客服',
				department: '客服部',
				location: '成都',
				type: '全职',
				description: '<h3>职位描述</h3><ul><li>填制各种单据，按客人要求出分单或寄走全套运单文件</li><li>接收报关核对单的检查;交接单内容、正本鉴定及制单要求的核对;出重后，对运单的内容再次复核，查看等级、比例等要求是否满足;随机文件的整理;</li><li>熟练使用办公软件如Excel、Word;熟练掌握使用公司操作系统以及其他相关系统的操作;</li></ul><h3>职位要求</h3><ul><li>统招专科及以上学历，1-2年同行业工作经验优先:</li><li>应届毕业生有国际贸易、物流等相关专业优先;</li><li>具有良好的学习能力、抗压能力、沟通及语言表达能力;</li></ul>'
			}
		],
		sendResume: '简历请投递至邮箱',
		benefits: 'What We Offer',
		benefitList: [
			'Competitive salary and benefits ',
			'Career growth and training opportunities',
			'Flexible holiday and vacation system',
			'Open & inclusive working environment'
		],
		benefitTitles: ['Salary and Benefits', 'Growth Training', 'Holidays', 'Team Culture']
	},
	aboutUS: {
		title: "Contact Us",
		description: "泛思特是一家拥有15年以上国际货运经验的全球领先物流供应商。",
		mission: "我们的使命",
		missionContent: "提供创新可靠的运输解决方案，为全球客户创造价值。",
		vision: "我们的愿景",
		visionContent: "成为全球供应链管理中最值得信赖的合作伙伴。",
		values: "我们的价值观",
		valuesList: [
			"客户至上",
			"诚信透明",
			"创新卓越",
			"团队协作"
		],
		history: "发展历程",
		historyContent: [
			"2008年成立于上海，最初只有5名员工",
			"2015年业务扩展至10个国家",
			"2020年在香港证券交易所上市",
			"目前在25个国家开展业务，拥有2000多名员工"
		],
		team: "我们的团队",
		teamContent: "我们拥有一支经验丰富、具备深厚行业知识和全球视野的专业团队。"
	},
	contactInfo: {
		title: "Contact Us",
		ourContact: "Our Contact Information",
		address: "Company Address",
		companyAddress: "Room E707, 7F, Building 2, Court No. 8, North Airport Street, Shunyi District, Beijing",
		viewMap: "查看地图",
		phone: "Tel.",
		businessPhone: "Business Consulting",
		customerService: "客户服务",
		email: "Email",
		businessEmail: "Business Consulting",
		customerServiceEmail: "客户服务",
		followUs: "关注我们",
		wechatQR: "微信公众号二维码",
		scanQR: "扫码关注公众号",
		onlineConsultation: "在线咨询",
		name: "姓名",
		namePlaceholder: "请输入您的姓名",
		company: "公司名称",
		companyPlaceholder: "请输入您的公司名称",
		emailPlaceholder: "请输入您的电子邮箱",
		phonePlaceholder: "请输入您的联系电话",
		subject: "咨询主题",
		selectSubject: "请选择咨询主题",
		airFreight: "航空货运",
		seaFreight: "海运服务",
		customsClearance: "报关服务",
		other: "其他",
		message: "咨询内容",
		messagePlaceholder: "请详细描述您的需求...",
		submitting: "提交中...",
		submit: "提交咨询",
		submitSuccess: "感谢您的咨询！我们会尽快与您联系。",
		globalOffices: "Offices in China",
		offices: [{
				id: 1,
				city: "Beijing, China ",
				country: "",
				address: "Room E707, 7F, Building 2, Court No. 8, North Airport Street, Shunyi District, Beijing",
			},
			{
				id: 2,
				city: "Shanghai, China",
				country: "",
				address: "No. 588, Tingzhong Village, Zhuqiao Town, Pudong New Area, Shanghai ",
			},
			{
				id: 3,
				city: "Guangzhou, China",
				country: "",
				address: "Room 305, Guangzhou Airport E-commerce International Industrial Park (Building A8), No.9 Airport Avenue, Huadong Town, Huadu District, Guangzhou",
			},
			{
				id: 4,
				city: "Zhengzhou, China",
				country: "",
				address: "Room 807, Tower B, Shihangzhichuan Mansion, 200m west of the intersection between Yungang Road and Auxiliary Road of Huaxia Avenue, Xuedian Town, Xinzheng City, Zhengzhou, Henan Province",
			},
			{
				id: 5,
				city: "Chengdu, China",
				country: "",
				address: "Room 210, Inbound Zone, Freight Station of Air China, International Freight Area, Tianfu International Airport, Jianyang City, Chengdu",
			}
		],
		countries: {
			china: "中国",
			singapore: "新加坡",
			japan: "日本",
			usa: "美国"
		},
	},
	consultationSection: {
		sectionTitle: "Product Compliance Consulting",
		sectionDescription: "Provide Professional Global Compliance Consulting Service for Your Cargo",
		services: {
			dataService: {
				category: "Data Service",
				title: "Self-owned powerful database",
				// text: "实时更新的国际运输法规数据库，覆盖190+国家地区，每月5000+条数据更新",
				features: [
					"Store more than 200,000 product conclusions",
					"Update above 200 new conclusions every day",
					"All conclusions are from identification institutions, ensuring accuracy and authority"
				]
			},
			certificationService: {
				category: "Authentication Service",
				title: "Authoritative appraisal report",
				// text: "与全球20+认证机构合作，提供具有法律效力的鉴定报告，24小时快速出证",
				features: [
					"Own transportation qualification recognized by International Air Transport Association (IATA)",
					"Recognized by CNAS",
					"Cooperate with multiple identification institutions and achieve quickly certificate issuance",
					"Provide HS consulting service"
				]
			},
			mobileApp: {
				category: "Mobile App",
				title: 'Self - service appraisal Mini Program "Air Cargo Appraisal"',
				AirCargoAppraisal: "",
				// text: "全球首款整合多式联运合规要求的专业工具，已服务于10,000+企业，助力高效、安全、合规运输。",
				features: [
					"Super engine for data appraisal",
					"Cargo conclusions and hazardous goods package requirements provided",
					"Real-time updated for query on mobile phone at any time"
				]
			}
		},
		partnersSectionTitle: "Cooperative Institutions for Classification and Identification",
		partners: [{
				name: "DGM",
				alt: "DGM"
			},
			{
				name: "SINO",
				alt: "SINO"
			},
			{
				name: "SICIT",
				alt: "SICIT"
			},
			{
				name: "The Second Research Institute of CAAC",
				alt: "The Second Research Institute of CAAC"
			},
			{
				name: "STS",
				alt: "STS"
			}
		]
	},
	footer: {
		title: 'Look forward to wonderful cooperation with you',
		contactPrompt: "Please contact us at any time and let's jointly explore infinite possibilities.",
		address: 'Address:  Room E707, 7F, Building 2, Court No. 8, North Airport Street, Shunyi District, Beijing',
		qq: 'Enterprise QQ: 2355807082',
		phone: 'Tel.:  13401038003',
		fax: 'Fax:  010-64564249',
		email: 'E-mail:  liuqian@fst.net.cn',
		copyright: '© 2025 泛思特国际运输 版权所有',
		beian: {
			publicSecurity: '京公网安备 11011302005688号',
			publicSecurityUrl: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302005688',
			icp: '京ICP备13034572号-1',
			icpUrl: 'https://beian.miit.gov.cn/#/Integrated/index'
		}
	},
	airlines: [{
			name: '',
			logo: 'LH.jpg'
		},
		{
			name: '',
			logo: 'guotai.jpeg'
		},
		{
			name: '',
			logo: 'Air-FranceKLM.png'
		},
		{
			name: '',
			logo: 'british-Airways.png'
		},
		{
			name: '',
			logo: 'hnhk.jpeg'
		},
		{
			name: '',
			logo: 'Etihad-Airways.jpg'
		},
		{
			name: '',
			logo: 'air-china.jpg'
		},
		{
			name: '',
			logo: 'china-eastern.png'
		},
		{
			name: '',
			logo: 'china-southern.jpg'
		},
		{
			name: '',
			logo: 'sichuan-air.png'
		},
		{
			name: '',
			logo: 'Turkey.jpg'
		},
		{
			name: '',
			logo: 'Boli-USA.jpg'
		},
		{
			name: '',
			logo: 'Swiss-Air.png'
		},
		{
			name: '',
			logo: 'ek.jpg'
		},
		{
			name: '',
			logo: 'South-Korea.jpg'
		},
		{
			name: '',
			logo: 'usa.png'
		},
		{
			name: '',
			logo: 'Singapore.jpg'
		},
		{
			name: '',
			logo: 'Poland.jpg'
		},
		{
			name: '',
			logo: 'qatar.jpg'
		},
		{
			name: '',
			logo: 'united.png'
		},
		{
			name: '',
			logo: 'Russia.jpg'
		},
		{
			name: '',
			logo: 'thai.jpg'
		},
		{
			name: '',
			logo: 'miandian.jpg'
		},
		{
			name: 'More',
			logo: 'gd.jpg'
		}
	],
	shippingLines: [{
			name: '',
			code: 'MSK',
			logo: 'maersk.png'
		},
		{
			name: '',
			code: 'COSCO',
			logo: 'cosco.png'
		},
		{
			name: '',
			code: 'CMA',
			logo: 'cmacgm.png'
		},
		{
			name: '',
			code: 'ONE',
			logo: 'one.jpg'
		},
		{
			name: '',
			code: 'YML',
			logo: 'yml.png'
		},
		{
			name: '',
			code: 'MSC',
			logo: 'msc.png'
		},
		{
			name: '',
			code: 'EMC',
			logo: 'evergreen.png'
		},
		{
			name: '',
			code: 'WHL',
			logo: 'wanhai.png'
		},
		{
			name: '',
			code: 'OOCL',
			logo: 'oocl.jpg'
		},
		{
			name: 'More',
			logo: 'gd.jpg'
		}
	],
	map: {
		title: "Beijing Fanst International Transport Agency Co., Ltd.",
		googleMap: "Google Maps",
		baiduMap: "Baidu Map",
		companyLocation: "Company Location",
	},

}